import { Component, Input } from "@angular/core";
import { Invoice } from "../invoice";

@Component({
  selector: "invoice-accounting-status",
  styleUrls: ["./invoice-accounting-status.component.css"],
  templateUrl: "./invoice-accounting-status.component.html"
})
export class InvoiceAccountingStatus {
  @Input()
  invoice!: Invoice;

  @Input()
  quickbookUrl!: string;
}